import type { DateTime } from 'luxon'

import { useActivationGroupsQuery } from '@/features/activationGroup/hooks/useActivationGroupsQuery'
import type { ActivationGroup } from '@/features/activationGroup/types'
import { useCommitments } from '@/features/bidding/hooks/useCommitments'
import type { AllocatedVolumes } from '@/features/bidding/types/allocatedVolumes'
import { MarketDate } from '@/features/bidding/utils/date/marketDate'

export type BidDashboardData = {
  activationGroups: ActivationGroup[] | undefined
} & ({ isLoading: true; allocatedVolumes: null } | { isLoading: false; allocatedVolumes: AllocatedVolumes })

export function useBidDashboardData(
  countryCode: CountryIdentifier | undefined,
  portfolioCode: string,
  selectedDeliveryDay: DateTime,
): BidDashboardData {
  const { activationGroups, isLoading: isLoadingGroups } = useActivationGroupsQuery(
    countryCode ? { countryCode } : undefined,
    { enabled: !!countryCode },
  )

  const { allocatedVolumes, isLoading: isLoadingAllocatedVolumes } = useCommitments(
    new MarketDate(selectedDeliveryDay),
    portfolioCode,
    !!portfolioCode,
  )

  const liveSortedGroups = activationGroups
    ?.filter((i) => i.state === 'LIVE')
    .sort((a, b) => a.code.localeCompare(b.code))

  return {
    activationGroups: liveSortedGroups,
    allocatedVolumes: allocatedVolumes as AllocatedVolumes,
    isLoading: isLoadingGroups || isLoadingAllocatedVolumes,
  } as BidDashboardData
}
